import { useTheme } from 'styled-components';

import { StrongText, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { SpinnerGradientDefs } from '../icons/SpinnerGradientDefs';
import { translationKeys } from '../translations';

import { AiAssistantMainMenuTileItemContainer } from './AiAssistantMainMenuTileItemContainer';
import { StyledCollapsedSpinnerIcon, StyledStandardSpinner } from './AiAssistantMainMenuTileItemPending.styled';

const t = translationKeys.mainMenuTileItem;

export const AiAssistantMainMenuTileItemMobilePending = (): JSX.Element => {
   const theme = useTheme();

   return (
      <AiAssistantMainMenuTileItemContainer
         icon={
            <StyledCollapsedSpinnerIcon alignItems={'center'} justifyContent={'center'}>
               <>
                  <SpinnerGradientDefs />
                  <StyledStandardSpinner />
               </>
            </StyledCollapsedSpinnerIcon>
         }
         backgroundColor={theme.backgroundBody}
      >
         <StyledFlex direction={'column'} gap={4} alignItems={'center'} justifyContent={'center'}>
            <>
               <SpinnerGradientDefs />
               <StyledStandardSpinner />
            </>
            <StrongText testId={'creatingNote'}>
               <Translate>{t.creatingNote}</Translate>
            </StrongText>
         </StyledFlex>
      </AiAssistantMainMenuTileItemContainer>
   );
};
